export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref12877.463e405e.jpg";